import { Group } from '@visx/group';

import { useTheme } from '@simplywallst/ui-core';

import type { HierarchyPointNode } from '../../types';

import { getBranchWidth } from '../../utils';
import { useSVGElementWidth } from '@/hooks/useSVGElementWidth';

import { VisxText } from '@/components/VisxText';

type Props = {
  node: HierarchyPointNode;
};

export const Root = ({ node }: Props) => {
  const theme = useTheme();
  const value = getBranchWidth(node.data.weight);
  const offset = value / 2;
  const [ref, width] = useSVGElementWidth();
  return (
    <Group top={node.x + offset + theme.x1spacePx} left={node.y}>
      <VisxText
        innerRef={ref}
        typography="xSmall"
        verticalAnchor="start"
        textAnchor="start"
        fill={theme.color.white}
      >
        {node.data.name}
      </VisxText>
      <VisxText
        x={width + theme.x0_5}
        typography="xSmall"
        verticalAnchor="start"
        textAnchor="start"
        fill={theme.color.whiteRGBA(0.5)}
      >
        100%
      </VisxText>
    </Group>
  );
};
